import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device, Page, SearchRequest } from '../model';
import { Crud } from './crud-abstract';

@Injectable({
  providedIn: 'root'
})
export class DeviceService extends Crud<Device> {

  override baseUrl = 'api/devices';

  search(request: SearchRequest): Observable<Page<Device>> {
    return this.http.get<Page<Device>>(`${this.baseUrl}/search`, { params: { ...request } });
  }

  callback(device: Device) {
    return this.http.post(`${this.baseUrl}/${device.id}/command/CALL_SERVER`, null);
  }
}
